import {
  SET_CURRENT_CREW_FILE,
  SET_EXPERIENCE,
  SET_INVITE_TRIP, SET_IS_MORE_TRIPS,
  SET_TRIP_INVITATIONS,
  SET_TRIPS
} from "./logbook-types";


const initialState = {
  trips: null,
  inviteTrip: null,
  currentCrewFile: null,
  tripInvitations: [],
  experience: null,
  isMoreTrips: true
}

export const logbookReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRIPS: return {...state, trips: action.trips}
    case SET_INVITE_TRIP: return {...state, inviteTrip: action.inviteTrip}
    case SET_CURRENT_CREW_FILE: return {...state, currentCrewFile: action.currentCrewFile}
    case SET_TRIP_INVITATIONS: return {...state, tripInvitations: action.tripInvitations}
    case SET_EXPERIENCE: return {...state, experience: action.experience}
    case SET_IS_MORE_TRIPS: return {...state, isMoreTrips: action.isMoreTrips}
    default: return state
  }
}
